module.exports = __webpack_public_path__ + "6dea51e9744d82adec021bf23905f3e4.jpg";